/* Copyright © ClickaByte Ltd - All Rights Reserved
  Unauthorized copying of this file, via any medium is strictly prohibited
  Proprietary and confidential
  Written by George Barnes <info@clickabyte.co.uk>, October 2025
*/

const onReady = (cb) =>
  (document.readyState === 'complete' || document.readyState === 'interactive')
    ? cb()
    : document.addEventListener('DOMContentLoaded', cb, { once: true });

const raf = (fn) => requestAnimationFrame(fn);

const ric = (cb, { timeout } = {}) => {
  if ('requestIdleCallback' in window) return requestIdleCallback(cb, { timeout });
  const start = performance.now();
  return raf(() => cb({ didTimeout: false, timeRemaining: () => Math.max(0, 50 - (performance.now() - start)) }));
};
const cancelRic = (id) => ('cancelIdleCallback' in window ? cancelIdleCallback(id) : cancelAnimationFrame(id));

const FORCE_MOTION = true;

if (FORCE_MOTION) {
  document.documentElement.classList.add('force-motion');
}

/* ---------- playback gate ---------- */
window.__playbackGate = {
  scrolling: false,
  pageVisible: document.visibilityState === 'visible',
  heroVisible: false,
};

/* ---------- Turbo scroll mode (pause-all-except-leaves) ---------- */
(() => {
  let ownLenisLoop = null;

  // Selectors that identify animations which should KEEP running during turbo/scroll.
  // You can tweak or extend this at runtime: window.scrollSafeSelectors.push('.my-other-safe-thing')
  window.scrollSafeSelectors = window.scrollSafeSelectors || [
    '.leaf',
    '[data-leaf]',
    '[data-anim="leaves"]',
    '[data-scroll-safe]'
  ];

  // Helper: allow marking a specific element OR GSAP animation as "scroll-safe".
  const scrollSafeEls = new WeakSet();
  const scrollSafeAnims = new WeakSet();
  window.markScrollSafe = function markScrollSafe(target) {
    if (!target) return;
    // If it's a GSAP animation (Tween/Timeline), remember it directly:
    if (typeof target === 'object' && ('time' in target || 'totalTime' in target)) {
      scrollSafeAnims.add(target);
      return;
    }
    // Otherwise assume it's a DOM element:
    if (target instanceof Element) scrollSafeEls.add(target);
  };

  function isElementScrollSafe(el) {
    if (!el) return false;
    if (scrollSafeEls.has(el)) return true;
    try {
      return window.scrollSafeSelectors.some(sel => el.matches?.(sel));
    } catch(_) { return false; }
  }

  function animTargets(anim) {
    // Try public API first, then fall back to private _targets if needed.
    try {
      const t = typeof anim.targets === 'function' ? anim.targets() : (anim.targets || anim._targets);
      return Array.isArray(t) ? t : [];
    } catch (_) { return []; }
  }

  function isAnimScrollSafe(anim) {
    if (!anim) return false;
    if (scrollSafeAnims.has(anim)) return true;

    // Common “tag” patterns you might use when creating the tween/timeline
    if (anim.data === 'leaves') return true;
    if (anim.vars?.id === 'leaves') return true;
    if (anim.vars?.scrollSafe === true) return true;

    // If any target element matches a scroll-safe selector, exempt it
    const targets = animTargets(anim);
    for (const el of targets) {
      if (isElementScrollSafe(el)) return true;
    }
    return false;
  }

  // Track which animations we paused so we can resume only those.
  const pausedAnims = new Set();

  function pauseAllExceptScrollSafe() {
    if (!window.gsap) return;
    pausedAnims.clear();

    const tl = gsap.globalTimeline;
    // true,true,true => get tweens, timelines, and nested children
    const kids = tl.getChildren(true, true, true);

    for (const k of kids) {
      if (!k || k === tl) continue;
      if (isAnimScrollSafe(k)) continue;      // skip leaves / safe anims
      if (k.paused()) continue;               // already paused by you
      try {
        k.pause();
        pausedAnims.add(k);
      } catch {}
    }
  }

  function resumePreviouslyPaused() {
    for (const k of pausedAnims) {
      if (!k) continue;
      try {
        // Only resume if still paused and not killed
        if (k.paused() && !k._killed) k.resume();
      } catch {}
    }
    pausedAnims.clear();
  }

  function startOwnLenisLoop() {
    if (ownLenisLoop || !window.lenis) return;
    const step = (t) => { if (ownLenisLoop) { window.lenis.raf(t); ownLenisLoop = requestAnimationFrame(step); } };
    ownLenisLoop = requestAnimationFrame(step);
  }
  function stopOwnLenisLoop() {
    if (!ownLenisLoop) return;
    cancelAnimationFrame(ownLenisLoop);
    ownLenisLoop = null;
  }

  window.__turboScroll = {
    enter() {
      // Pause non-leaf GSAP animations; keep “leaves” running
      pauseAllExceptScrollSafe();

      // Keep Lenis on its own RAF so scrolling stays buttery even if GSAP is idle
      startOwnLenisLoop();
    },
    exit() {
      // Resume only what we paused ourselves
      resumePreviouslyPaused();

      stopOwnLenisLoop();
    }
  };
})();



/* ---------- footer year ---------- */
onReady(() => {
  const el = document.getElementById('footer-year');
  if (el) el.textContent = String(new Date().getFullYear());
});

/* ---------- mobile menu ---------- */
function waitForMenu(selector, time) {
        if(document.querySelector(selector)!=null) {
          const btn = document.querySelector('.menu-btn');
          const drawer = document.getElementById('mobileMenu');
          if (!btn || !drawer) return;

          btn.addEventListener('click', () => {
            const open = drawer.classList.toggle('open');
            btn.setAttribute('aria-expanded', String(open));
          });

          drawer.addEventListener('click', (e) => {
            const t = e.target;
            if (t && t.tagName === 'A') {
              drawer.classList.remove('open');
              btn.setAttribute('aria-expanded', 'false');
            }
          });
          
          (function markActiveNav(){
            const path = location.pathname.replace(/\/$/, '');   // remove trailing slash
            const links = document.querySelectorAll('nav a[href], #mobileMenu a[href]');

            links.forEach(a => {
                const url = new URL(a.getAttribute('href'), location.origin);
                const hrefPath = url.pathname.replace(/\/$/, '');

                // treat "/" and "" as same
                const isHome = (p) => p === '' || p === '/';
                const match = (isHome(path) && isHome(hrefPath)) || (!isHome(path) && hrefPath === path);

                if (match) a.setAttribute('aria-current', 'page');
                else a.removeAttribute('aria-current');
            });
})();


          return;
        } else setTimeout(()=>waitForMenu(selector, time), time);
    }
(() => {
    waitForMenu('.site-header',300);
})();

/* ---------- sticky header ---------- */
onReady(() => {
  const header = document.getElementById('siteHeader');
  if (!header) return;

  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'position:absolute;inset:0 auto auto 0;width:1px;height:1px;pointer-events:none;';
  header.before(sentinel);

  const io = new IntersectionObserver(entries => {
      if (window.__playbackGate.scrolling) return;
    const top = entries[0];
    header.classList.toggle('is-stuck', !top.isIntersecting);
  }, { rootMargin: '-80px 0px 0px 0px' });

  io.observe(sentinel);
});

/* ---------- smooth scroll ---------- */
onReady(() => {
  if (window.Lenis && typeof window.Lenis === 'function') {
    const lenis = new Lenis({
      autoRaf: false,
      duration: 1.2,
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 1.5
    });
    window.lenis = lenis;
    document.documentElement.classList.add('lenis-enabled');

    // Use the same clock as GSAP
    if (window.gsap?.ticker) {
        gsap.ticker.fps(-1); 
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      // make GSAP tolerant of occasional long frames
      gsap.ticker.lagSmoothing(1000,16);
    } else {
      // fallback if GSAP not ready for some reason
      const loop = (time) => { lenis.raf(time); requestAnimationFrame(loop); };
      requestAnimationFrame(loop);
    }
  }
});


/* ---------- pointer ---------- */
/* ---------- pointer (HARD disable during scroll; idle reattach) ---------- */
(() => {
  const V_ENTER  = 0.051;   // start "scrolling" above this velocity
  const V_EXIT   = 0.05;   // stop "scrolling" below this velocity (hysteresis)
  const QUIET_MS = 220;    // how long after the last scroll event to reattach

  let scrolling = false;
  let quietTimer = 0;
  let attachTimer = 0;
  let active = false;          // whether PointerRipple is currently attached
  let gen = 0;                 // token to prevent out-of-order reattach

  const canUse = () =>
    matchMedia('(pointer:fine)').matches &&
    typeof window.PointerRipple?.attach === 'function';

  function hardDetach() {
    if (!active) return;
    try { window.PointerRipple.detach(); } catch {}
    active = false;
  }

  function scheduleAttachIdle(token) {
    // use requestIdleCallback if available; otherwise minimal fallback
    const idle = ('requestIdleCallback' in window)
      ? (cb) => requestIdleCallback(cb, { timeout: 500 })
      : (cb) => setTimeout(() => cb({ didTimeout: true, timeRemaining: () => 0 }), 0);

    // avoid heavy work in same tick as scroll end; wait a frame, then idle
    cancelAnimationFrame(scheduleAttachIdle._raf || 0);
    scheduleAttachIdle._raf = requestAnimationFrame(() => {
      idle(() => {
        // stale? bail
        if (token !== gen) return;
        if (document.visibilityState !== 'visible') return;
        if (!canUse()) return;
        if (active) return;

        try {
          window.PointerRipple.attach({
              rippleOnly: true,
            lineWidth: 4,
            haloOpacity: 0,
            // keep DPR adaptive if you like; not critical for overhead once attached
          });
          active = true;
        } catch {}
      });
    });
  }

  function enterScroll() {
    if (scrolling) return;
    scrolling = true;
    clearTimeout(quietTimer);
    clearTimeout(attachTimer);
    hardDetach();      // ← remove all listeners/RAF/DOM from the ripple
  }

  function scheduleExitScroll() {
    // Debounce "idle" so we don't thrash attach/detach on tiny changes
    clearTimeout(quietTimer);
    const token = ++gen; // invalidate older attach attempts
    quietTimer = setTimeout(() => {
      scrolling = false;
      // small delay keeps reattach away from end-of-scroll paint
      clearTimeout(attachTimer);
      attachTimer = setTimeout(() => scheduleAttachIdle(token), 30);
    }, QUIET_MS);
  }

  onReady(() => {
    if (!canUse()) return;         // nothing to do on coarse pointers
    // Attach once on load (will be torn down as soon as we scroll)
    try { window.PointerRipple.attach({
              rippleOnly: true,
            lineWidth: 4,
            haloOpacity: 0,
            // keep DPR adaptive if you like; not critical for overhead once attached
          });
          active = true; } catch {}

    if (!window.lenis) return;

    window.lenis.on('scroll', (e) => {
      const v = Math.abs(e.velocity ?? 0);
      const wantScrolling = scrolling ? v > V_EXIT : v > V_ENTER;
      if (wantScrolling) enterScroll();
      // Always schedule a potential exit when events come in
      scheduleExitScroll();
    });
  });

  // Safety: fully detach while hidden; reattach after a quiet beat when visible again
  addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') {
      ++gen; // invalidate pending attaches
      clearTimeout(quietTimer); clearTimeout(attachTimer);
      hardDetach();
      scrolling = false;
    } else {
       const token = ++gen;
       clearTimeout(attachTimer);
       // wait an extra frame then idle—tabs often do a burst of work on show
       attachTimer = setTimeout(() => scheduleAttachIdle(token), QUIET_MS + 60);
   }
  }, { passive: true });
})();


/* ---------- hero stuff ---------- */
(() => {
  const hero  = document.querySelector('.hero');
  const video = document.querySelector('.hero-video');
  if (!hero || !video) return;

  const RATE = 1;
  const setRateOnce = () => { video.defaultPlaybackRate = RATE; video.playbackRate = RATE; };
  if (video.readyState >= 1) setRateOnce(); else video.addEventListener('loadedmetadata', setRateOnce, { once: true });

  video.setAttribute('muted', '');
  function tryPlayNow() {
    const p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {
        setTimeout(() => { video.muted = true; video.setAttribute('muted',''); video.play().catch(()=>{}); }, 60);
      });
    }
  }

  const prefersReduce = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer  = matchMedia('(pointer:fine)');

  const cfg = { maxX:34, maxY:20, biasY:0.22, baseScale:1.02, scaleDelta:0.02 };
  let target = { x:0, y:0, s:cfg.baseScale };
  let cur    = { x:0, y:0, s:cfg.baseScale };
  const lerp = (a,b,t)=>a+(b-a)*t;

  let running = false;
  let rafId = 0;
  const EPS = 0.08, EPS_S = 0.0008;

  const loop = () => {
    if (!running) return;
    const ease = 0.18;
    const nx = lerp(cur.x, target.x, ease);
    const ny = lerp(cur.y, target.y, ease);
    const ns = lerp(cur.s, target.s, ease);

    if (Math.abs(nx - cur.x) > EPS) { cur.x = nx; hero.style.setProperty('--mx', cur.x.toFixed(2) + 'px'); } else { cur.x = nx; }
    if (Math.abs(ny - cur.y) > EPS) { cur.y = ny; hero.style.setProperty('--my', cur.y.toFixed(2) + 'px'); } else { cur.y = ny; }
    if (Math.abs(ns - cur.s) > EPS_S) { cur.s = ns; hero.style.setProperty('--ms', cur.s.toFixed(3)); } else { cur.s = ns; }

    rafId = requestAnimationFrame(loop);
  };

  function startParallax(){
    const ignoreRM = document.documentElement.classList.contains('force-motion');
    if (!running && (!prefersReduce.matches || ignoreRM)) {
      running = true;
      rafId = requestAnimationFrame(loop);
    }
  }
  function stopParallax(){ running = false; cancelAnimationFrame(rafId); }

  const startPlayback = () => tryPlayNow();
  const pausePlayback = () => { try { video.pause(); } catch {} };

  function sync(){
    const g = window.__playbackGate;
    const canPlay = g.pageVisible && g.heroVisible && !g.scrolling;
    if (canPlay){ startParallax(); startPlayback(); } else { stopParallax(); pausePlayback(); }
  }

  window.parallaxControl = { video, sync };

  addEventListener('visibilitychange', () => {
    const visible = (document.visibilityState === 'visible');
    window.__playbackGate.pageVisible = visible;
    if (!visible) pausePlayback();
    sync();
  }, { passive: true });

  const io = new IntersectionObserver(entries => {
    const vis = entries[0].isIntersecting;
    window.__playbackGate.heroVisible = !!vis;
    sync();
  }, { threshold: 0.01 });
  io.observe(hero);

  let rect = hero.getBoundingClientRect();
  const ro = ('ResizeObserver' in window) ? new ResizeObserver(() => {
     if (window.__playbackGate.scrolling) return; // skip during scroll to reduce work
     rect = hero.getBoundingClientRect();
   }) : null;
  ro?.observe(hero);

  let pmQueued = false, lastEvt = null;
  const flushPointer = () => {
      if (window.__playbackGate.scrolling) { pmQueued = false; return; }
    pmQueued = false;
    const e = lastEvt; if (!e) return;
    const nx = (e.clientX - rect.left) / rect.width;
    const ny = (e.clientY - rect.top)  / rect.height;
    target.x = (nx - 0.5) * cfg.maxX;
    target.y = (ny - cfg.biasY) * cfg.maxY;
    target.s = cfg.baseScale + (0.5 - Math.min(ny,0.8)) * cfg.scaleDelta;

    hero.style.setProperty('--gx', (nx*100).toFixed(2) + '%');
    hero.style.setProperty('--gy', (Math.min(ny,0.6)*100).toFixed(2) + '%');
  };
  const pointerMove = (e) => {
     if (window.__playbackGate.scrolling) return; // skip during scroll
     lastEvt = e;
     if (!pmQueued) { pmQueued = true; raf(flushPointer); }
   };

  const handlePointerMode = () => {
  const ignoreRM = document.documentElement.classList.contains('force-motion');
  if (finePointer.matches && (!prefersReduce.matches || ignoreRM)) {
      hero.addEventListener('mousemove', pointerMove, { passive: true });
      hero.addEventListener('mouseleave', () => { target = { x:0, y:0, s:cfg.baseScale }; }, { passive: true });
    } else {
      hero.removeEventListener('mousemove', pointerMove);
    }
  };
  handlePointerMode();
  finePointer.addEventListener('change', handlePointerMode, { passive: true });
  prefersReduce.addEventListener('change', handlePointerMode, { passive: true });

  const kick = () => window.parallaxControl?.sync?.();
  addEventListener('touchstart', kick, { once: true, passive: true });
  addEventListener('pointerdown', kick, { once: true, passive: true });

  sync();
})();

/* ---------- hero source attach ---------- */
(() => {
  const v = document.getElementById('heroVid');
  const media = v?.closest('.hero-media');
  if (!v || !media) return;

  function attachSources(){
    if (v.dataset.attached === '1') return;
    v.querySelectorAll('source').forEach(s => { if (!s.src && s.dataset.src) s.src = s.dataset.src; });
    v.load();
    v.dataset.attached = '1';
    media.dataset.unloaded = '0';
  }

  const io2 = new IntersectionObserver(([entry]) => {
      if (window.__playbackGate.scrolling) return;
    const visible = entry.isIntersecting && entry.intersectionRatio > 0.2;
    if (visible){ attachSources(); window.parallaxControl?.sync?.(); }
  }, { threshold: [0, 0.2] });
  io2.observe(v);

  addEventListener('visibilitychange', () => { if (document.visibilityState !== 'visible') { try { v.pause(); } catch {} } }, { passive: true });
})();

/* ---------- unified scroll gate (smoothed, debounced, dwell-protected) ---------- */
(() => {
  // Tunables
  const ENTER_V     = 0.10;   // need higher velocity to ENTER scrolling
  const EXIT_V      = 0.05;   // lower velocity to EXIT (hysteresis)
  const EMA_ALPHA   = 0.22;   // velocity smoothing factor (0..1) – higher = more responsive
  const MIN_ON_MS   = 220;    // minimum time to stay in "scrolling" once entered
  const MIN_OFF_MS  = 160;    // minimum time to stay "not scrolling" once exited
  const QUIET_OFF_MS= 140;    // extra quiet time after velocity falls below EXIT before flipping off
  const THROTTLE_MS = 32;     // process at most every ~2 frames on 60Hz
  const INACTIVITY_MS = 220;

  let scrolling = false;
  let emaV = 0;
  let lastFlipTs = 0;
  let lastProcessTs = 0;
  let quietTimer = 0;
  let token = 0; // cancel stale timers
  let inactivityTimer = 0;

  function flip(toScrolling){
    if (scrolling === toScrolling) return;
    scrolling = toScrolling;
    lastFlipTs = performance.now();
    window.__playbackGate.scrolling = scrolling;
    document.documentElement.classList.toggle('scrolling', scrolling);
    // turbo hooks if you added them:
    if (scrolling) window.__turboScroll?.enter?.(); else window.__turboScroll?.exit?.();
    window.parallaxControl?.sync?.();
  }
  
  function armInactivityWatch(){
   clearTimeout(inactivityTimer);
   inactivityTimer = setTimeout(() => {
     // If we’re still flagged scrolling but got no events for a while, force exit.
     if (scrolling) flip(false);
   }, INACTIVITY_MS);
 }

  function onScrollEvent(vRaw){
    const now = performance.now();
    // Throttle handling to cut flicker from very frequent events
    if (now - lastProcessTs < THROTTLE_MS) return;
    lastProcessTs = now;
    
    armInactivityWatch();

    const v = Math.abs(vRaw || 0);
    // EMA smoothing of velocity
    emaV += EMA_ALPHA * (v - emaV);

    if (!scrolling) {
      // Consider entering only if smoothed velocity passes ENTER and we've honored MIN_OFF_MS
      if (emaV > ENTER_V && (now - lastFlipTs) > MIN_OFF_MS) {
        clearTimeout(quietTimer); token++;
        flip(true);
      }
      return;
    }

    // We are scrolling: consider exit only if smoothed velocity is below EXIT
    if (emaV < EXIT_V) {
      // Debounce exit with a quiet timer + honor MIN_ON_MS
      const myToken = ++token;
      clearTimeout(quietTimer);
      const wait = Math.max(QUIET_OFF_MS, MIN_ON_MS - (now - lastFlipTs));
      quietTimer = setTimeout(() => {
        if (myToken !== token) return;           // stale
        // double-check: velocity still low after quiet period
        if (emaV < EXIT_V) flip(false);
      }, wait);
    } else {
      // still active: cancel any pending exit
      clearTimeout(quietTimer);
    }
  }

  // Wire to Lenis
  if (window.lenis) {
    window.lenis.on('scroll', (e) => onScrollEvent(e?.velocity));
    armInactivityWatch();
  } else {
    // Fallback sampler (no Lenis): infer velocity from scrollY
    let lastY = window.scrollY, lastTs = performance.now();
    const loop = () => {
      const ts = performance.now();
      const dy = Math.abs(window.scrollY - lastY);
      const dt = Math.max(1, ts - lastTs);
      lastY = window.scrollY; lastTs = ts;
      const vApprox = dy / dt; // px per ms (rough)
      onScrollEvent(vApprox);
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  // Safety: on tab hide, ensure we’re not stuck in "scrolling"
  addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') {
      clearTimeout(quietTimer); token++;
      clearTimeout(inactivityTimer);
      emaV = 0;
      if (scrolling) flip(false);
    }
  }, { passive: true });
})();




(() => {
  // Wait until a modal with the given id exists, then init once.
  function whenModalReady(id, pollMs = 300) {
    const modal = document.getElementById(id);
    if (!modal) return setTimeout(() => whenModalReady(id, pollMs), pollMs);
    initModal(modal, id);
  }

  function initModal(modal, id) {
    const openBtns = document.querySelectorAll(`[data-open-modal="${id}"]`);
    const backdrop = modal.querySelector('.cf-modal__backdrop');
    const closeBtns = modal.querySelectorAll('[data-close-modal]');
    const form = modal.querySelector('#callbackForm') || modal.querySelector('form');
    const statusEl = modal.querySelector('.cf-modal__status');

    if (!openBtns.length) {
      // No openers yet; you can choose to return or keep polling for openers if desired.
      // For now, just return quietly.
      return;
    }

    let lastOpener = null;
    let prevFocus = null;

    openBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openModal(btn);
      });
    });

    closeBtns.forEach(btn => btn.addEventListener('click', closeModal));
    backdrop && backdrop.addEventListener('click', closeModal);

    form && form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (statusEl) statusEl.textContent = 'Sending…';
      const data = new FormData(form);

      try {
        const res = await fetch(form.action || '/request-callback', { method: 'POST', body: data });
        if (!res.ok) throw new Error('Network response was not ok');

        if (statusEl) statusEl.textContent = 'Thanks — we’ll call you shortly.';
        form.reset();
        setTimeout(closeModal, 1000);
      } catch (err) {
        if (statusEl) statusEl.textContent = 'Sorry, something went wrong. Please try again or call us on 020 8240 6522.';
      }
    });

    function openModal(openerEl) {
      lastOpener = openerEl || document.activeElement;
      modal.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      trapFocus(modal);
      const first = modal.querySelector('input, button, [href], select, textarea, [tabindex]:not([tabindex="-1"])');
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      releaseFocus();
      document.removeEventListener('keydown', onKeydown);
      if (lastOpener && typeof lastOpener.focus === 'function') {
        lastOpener.focus({ preventScroll: true });
      }
    }

    function onKeydown(e) {
      if (e.key === 'Escape') closeModal();
    }

    function trapFocus(container) {
      prevFocus = document.activeElement;
      const selectors = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
      const focusables = Array.from(container.querySelectorAll(selectors)).filter(el => !el.hasAttribute('disabled'));
      if (focusables.length === 0) return;

      function loop(e) {
        if (e.key !== 'Tab') return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      }
      container.addEventListener('keydown', loop);
      container._trapHandler = loop;
    }

    function releaseFocus() {
      if (prevFocus && typeof prevFocus.focus === 'function') {
        prevFocus.focus({ preventScroll: true });
      }
      if (modal._trapHandler) modal.removeEventListener('keydown', modal._trapHandler);
    }

    function lockScroll(locked) {
      document.documentElement.style.overflow = locked ? 'hidden' : '';
    }
  }

  // Boot: pass the id of your modal element
  whenModalReady('callbackModal', 300);
})();

